
import {
  computed,
  defineComponent,
  onMounted,
  PropType,
  reactive,
  ref
} from 'vue'
import { ethers } from 'ethers'
import erc20ABI from '@/contract/abi/erc20'
import redPackABI from '@/contract/abi/HappyRedPacket.json'
import BN from 'bignumber.js'
import { RedPacketContract } from '@/contract/func/redPacket'
import { TokenContract } from '@/contract/func/token'
import { useRoute } from 'vue-router'
import GreetingCard from './GreetingCard.vue'
import ChainTag from './ChainTag.vue'
import PersonalityButton from './common/PersonalityButton.vue'
import FxInput from './common/FxInput.vue'
import AccountConnect from './accountConnect.vue'
import { getChainId } from '@/composables/metamask'
import { IChainId } from '@/interface'
import { ITokenInfoRes } from '@/composables/fxwallet'
import { Tools } from '@/plugins/tools'
import { checkI18n } from '@/plugins/i18n'
import { useI18n } from 'vue-i18n'
import Loading from './common/loading.vue'
import WalletList from './WalletList/WalletList.vue'
import { useStore } from 'vuex'

export interface IRedPackData {
  totalToken: string;
  number: number;
  title: string;
}

export default defineComponent({
  components: {
    GreetingCard,
    PersonalityButton,
    FxInput,
    Loading,
    WalletList
  },

  props: {
    chainId: {
      type: Number as PropType<IChainId>,
      required: true
    },
    redPackContractAddr: {
      type: String,
      required: true
    },
    tokenInfo: {
      type: Object as PropType<ITokenInfoRes>,
      required: true
    },
    sendLoading: {
      type: Boolean
    },
    maxButQuantity: {
      type: Number as PropType<number>,
      required: true
    }
    // totalQuantityVal: {
    //   type: Number as PropType<number>,
    //   required: true
    // }
  },

  emits: ['sendNftBuy', 'setQuantity', 'connect'],

  setup (props, { emit }) {
    const { t } = useI18n()
    const route = useRoute()
    const query = route.query as { token: string }

    const store = useStore()

    const userInfo = computed(() => store.state.userInfo)

    const showLogin = ref(false)

    const totalQuantityReady = ref(false)

    const loading = reactive({
      approve: false,
      allowance: true
    })

    const colorText = ref('')

    const pieceListData = ref([
      {
        value: 1,
        text: '1 piece'
      },
      {
        value: 5,
        text: '5 pieces'
      },
      {
        value: 10,
        text: '10 pieces'
      }
    ])

    const pieceActive = ref(0)

    const pieceList = computed(() => {
      return pieceListData.value.filter((el) => {
        return Number(totalQuantityVal.value) >= el.value
      })
    })

    let tokenContract: TokenContract
    let redPackContract: RedPacketContract
    const totalQuantityVal = ref('0')

    // 红包信息
    const redPackData = reactive<IRedPackData>({
      totalToken: '1',
      number: 0,
      title: ''
    })

    const redPackDataTotalTokenDecimal = computed(() => {
      return Tools.amountPlusDecimal(
        redPackData.totalToken || '0',
        props.tokenInfo.decimals
      )
    })

    const approveHash = ref('')
    const approveStatus = ref('')
    const approveAllowance = ref('')
    const approveAllowanceLoading = ref(false)
    const sendStatus = ref(true)
    const redPackId = ref('')

    const stepStatus = ref(false)

    const textSendButton = ref('Send')

    const connectErrorMsg = ref('')

    /**
     * 是否允许发起交易
     * 配额大于输入的金额
     */
    const isAllowSend = computed(() => {
      return new BN(approveAllowance.value).gt(
        redPackDataTotalTokenDecimal.value
      )
    })

    const isCanSendTx = computed(() => {
      return isAllowSend.value
    })

    /**
     * 授权
     */
    async function approve () {
      console.log('-------> approve <----------')
      if (!window.provider) return

      loading.approve = true

      console.log(userInfo.value.redPackContractAddr)

      try {
        // // 授权
        const approveData = await tokenContract.tokenApprove({
          spender: userInfo.value.redPackContractAddr
        })

        approveHash.value = approveData.hash

        const txStatus = await window.provider.waitForTransaction(
          approveData.hash
        )

        console.log(txStatus)

        await allowance()

        if (new BN(approveAllowance.value).gt('0')) {
          stepStatus.value = false

          redPackNumberBlur()
        }
      } catch (error) {

      } finally {
        loading.approve = false
      }
    }

    /**
     * 查询配额
     */
    async function allowance () {
      if (!window.provider) return

      console.log('allowance')

      console.log('props.tokenInfo.contract', [
        userInfo.value.address,
        userInfo.value.redPackContractAddr
      ], props.tokenInfo.contract)

      approveAllowanceLoading.value = true

      const inter = new ethers.utils.Interface(erc20ABI)

      const data = inter.encodeFunctionData('allowance', [
        userInfo.value.address,
        userInfo.value.redPackContractAddr
      ])

      const rpcData = await window.provider.send('eth_call', [
        { data: data, to: props.tokenInfo.contract },
        'latest'
      ])

      approveAllowance.value = inter
        .decodeFunctionResult('allowance', rpcData)
        .toString()

      approveAllowanceLoading.value = false

      loading.allowance = false
    }

    /**
     * 创建红包
     */
    // function createRedPack () {
    //   emit('sendRedPack', {
    //     number: redPackData.number,
    //     title: 'a' + (redPackData.title || t('v1.0.defaultTitle')),
    //     tokenContract: props.tokenInfo.contract,
    //     tokenType: props.tokenInfo.contract ? 1 : 0,
    //     totalToken: redPackData.totalToken
    //   })
    // }

    function setPiece (val: number) {
      redPackData.number = val

      pieceActive.value = val

      redPackNumberBlur()
    }

    /**
     * nft购买
     */
    function nftBuy () {
      emit('sendNftBuy', {
        quantity: redPackData.number
        // title: 'a' + (redPackData.title || t('v1.0.defaultTitle')),
        // tokenContract: props.tokenInfo.contract,
        // tokenType: props.tokenInfo.contract ? 1 : 0,
        // totalToken: redPackData.totalToken
      })
    }

    function setTextSendButton (number: number) {
      const _QUANTITY = process.env.VUE_APP_QUANTITY as any
      const textval = new BN(number).multipliedBy(_QUANTITY).toString()
      textSendButton.value = `${Tools.getShowNumByNum(textval)} PURSE`
    }

    function redPackNumberBlur () {
      pieceActive.value = Number(redPackData.number) === 10 || Number(redPackData.number) === 5 || Number(redPackData.number) === 1 ? redPackData.number : 0
      if (redPackData.number > 10) {
        redPackData.number = 10

        // setTextSendButton(10)

        pieceActive.value = 10
      }
      if (redPackData.number > props.maxButQuantity) {
        textSendButton.value = 'Insufficient balance'
        sendStatus.value = true
        colorText.value = 'warn'
      } else {
        if (redPackData.number <= 0) {
          textSendButton.value = 'Send'
          sendStatus.value = true
          colorText.value = ''
          return false
        }
        setTextSendButton(redPackData.number)
        sendStatus.value = false
        colorText.value = ''
      }
    }

    function redPackNumberHandler (method: 'plus' | 'minu') {
      if (method === 'minu' && redPackData.number > 1) {
        redPackData.number--
      }

      if (method === 'plus' && redPackData.number < 255) {
        redPackData.number++
      }
    }

    async function connectHandler () {
      await getUserInfo()

      emit('connect', init)
    }

    async function init () {
      console.log('init', window.provider, props.tokenInfo.contract)

      if (window.provider && props.tokenInfo.contract) {
        // console.log(window.provider)

        try {
          redPackContract = new RedPacketContract(
            window.provider,
            userInfo.value.redPackContractAddr
          )

          const totalQuantity = await redPackContract.totalQuantity()

          totalQuantityVal.value = totalQuantity.toString()

          if (Number(totalQuantityVal.value) === 0) {
            throw new Error('Concluded')
          }

          await getUserInfo()

          tokenContract = new TokenContract(
            window.provider.getSigner(),
            props.tokenInfo.contract
          )

          // loading.allowance = true

          await allowance()

          console.log('approveAllowance', approveAllowance.value)

          if (approveAllowance.value === '0') {
            stepStatus.value = true
          }
        } catch (error) {

        }

        totalQuantityReady.value = true
      }
    }

    function connectErrorHandler (err: string) {
      connectErrorMsg.value = err
    }

    // 获取用户信息
    async function getUserInfo () {
      if (window.wallet) {
        const address = ethers.utils.getAddress(window.wallet.account)
        const balance = await window.wallet.getBalance(process.env.VUE_APP_COIN_ADDRESS) as ethers.BigNumber
        const chainId = window.wallet.chainId
        const redPackContractAddr = process.env.VUE_APP_CONTRACT

        // 保存用户信息
        store.commit('SET_USERINFO', {
          address,
          balance: balance.toString(),
          chainId,
          redPackContractAddr
        })
      }
    }

    onMounted(async () => {
      init()
    })

    return {
      approveHash,
      approveStatus,
      approveAllowance,
      approve,
      allowance,
      isAllowSend,
      isCanSendTx,
      stepStatus,
      nftBuy,
      redPackData,
      redPackNumberBlur,
      redPackNumberHandler,
      redPackId,
      loading,
      sendStatus,
      setPiece,
      textSendButton,
      colorText,
      pieceList,
      pieceActive,
      showLogin,
      connectHandler,
      connectErrorHandler,
      connectErrorMsg,
      totalQuantityReady,
      totalQuantityVal,
      userInfo,
      getUserInfo
    }
  }
})
